import APIService from '@/services/APIService.js';

export default {
  getAderencias(includeExpiredRecords) {
    return APIService.apiCall().get(`/aderenciaBdgd/getAderenciasBdgd/${includeExpiredRecords}`);
  },

  salvarAderenciaBdgd(postData) {
    return APIService.apiCall().post(`/aderenciaBdgd/salvar`, JSON.stringify(postData));
  },

  excluirAderenciaBdgd(id) {
    return APIService.apiCall().get(`/aderenciaBdgd/excluir/${id}`);
  },

  executarAderenciaBdgd(id) {
    return APIService.apiCall().get(`/aderenciaBdgd/executar/${id}`);
  },

  getDadosGrafico(id) {
    return APIService.apiCall().get(`/aderenciaBdgd/getDadosGrafico/${id}`);
  },

  download(id, config = {}) {
    return APIService.apiCall().get(`/aderenciaBdgd/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  }
};
